import { iMarker, isMarker } from "./iMarker";

export interface iSeriesItem {
    name: string;
    data: number[];
    color: string;
    marker?: iMarker;
    dashStyle?: string;
};

export default iSeriesItem;
export function isSeriesItem(obj: any): obj is iSeriesItem {
    return (
        obj &&
        typeof obj === 'object' &&
        typeof obj.name === 'string' &&
        typeof obj.data === 'object' &&
        Array.isArray(obj.data) &&
        (obj.data as any[]).every(s => typeof s === 'number') &&
        typeof obj.color === 'string' &&
        (obj.dashStyle === undefined || typeof obj.dashStyle === 'string') &&
        (obj.marker === undefined || isMarker(obj.marker))
    );
};